import './addTransaction.css';
import React, {Component} from "react";
import {
    PostPaymentRequestDto, UserDto, BasicUserDto
} from "../model/functionModels";
import TransactionService from "../services/transactionService";
import {Multiselect} from "multiselect-react-dropdown";
import DatePicker from "react-datepicker";
import CurrencyInput from "react-currency-input-field";
import Button from "./button";
import i18nService from "../../i18n/i18nService";

interface AddPaymentState {
    userPaidTo: UserRepresentation[],
    date: Date,
    amount: string,
    counter: number,
    isSubmitting: boolean,
}

interface AddPaymentProps {
    loggedInUser: UserDto,
    possibleUsers: (UserDto | BasicUserDto)[],
    onFailure: (a: string) => Promise<any>,
    onRedirection: (newUrl: string) => Promise<any>,
    refreshPageContent: any,
}

interface UserRepresentation {
    name: string,
    id: string
}

class AddPayment extends Component<AddPaymentProps, AddPaymentState> {

    constructor(props: AddPaymentProps) {
        super(props, {})
        this.handleAddPayment = this.handleAddPayment.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.state = {
            date: new Date(),
            userPaidTo: [],
            amount: '',
            counter: 1,
            isSubmitting: false,
        };
    }

    async handleAddPayment() {
        if (this.state.isSubmitting) {
            return;
        }
        this.setState({isSubmitting: true});
        try {
            const date = this.formatDate(this.state.date!);
            const amount = Math.floor(parseFloat(this.state.amount || "0") * 100);
            if (!amount || isNaN(amount)) {
                await this.props.onFailure(i18nService.t('dashboard.paymentForm.invalidAmount'));
                this.setState({isSubmitting: false});
                return;
            }
            if (!this.state.userPaidTo || this.state.userPaidTo.length === 0) {
                await this.props.onFailure(i18nService.t('dashboard.paymentForm.selectWhoWasPaid'));
                this.setState({isSubmitting: false});
                return;
            }
            await TransactionService.createPayment(
            {
                authorUserId: this.props.loggedInUser.id,
                userPaidTo: this.state.userPaidTo[0].id,
                date: date,
                amount: amount,
            } as PostPaymentRequestDto,
            async () => {
                // we clear the payment form
                this.setState({
                    date: new Date(),
                    userPaidTo: [],
                    amount: '',
                    counter: this.state.counter+1,
                    isSubmitting: false,
                });
                // we update the transactions list and the debt map
                await this.props.refreshPageContent();
            },
            async (e) => {
                this.setState({isSubmitting: false});
                await this.props.onFailure(e);
            },
            this.props.onRedirection);
        } catch (_e) {
            this.setState({isSubmitting: false});
        }
    }

    formatDate(date: Date) : string {
        return `${date.getFullYear()}-${(date.getMonth() + 1) > 9 ? "" : "0"}${date.getMonth() + 1}-${date.getDate() > 9 ? "" : "0"}${date.getDate()}`;
    }

    render() {
        return this.props.possibleUsers ? (
            <div className="AddTransaction-Wrapper">
                <div key="addTransactionUsers" className="AddTransaction-UserWhoIsPaidFor">
                    <Multiselect
                        key={"Multiselect-whoWasPaid-"+this.state.counter}
                        placeholder={i18nService.t('dashboard.paymentForm.whoWasPaid')}
                        options={this.props.possibleUsers.map(u => {
                            return {name: `${u.firstName} ${u.lastName}`, id: u.id} as UserRepresentation
                        })}
                        selectedValues={this.state.userPaidTo}
                        onSelect={(event) => {
                            this.setState({
                                userPaidTo: event
                            })
                        }
                        }
                        onRemove={(event) => {
                            this.setState({
                                userPaidTo: event
                            })
                        }
                        }
                        singleSelect={true}
                        displayValue="name"
                    />
                </div>
                <div className="AddTransaction-Date" key="addTransactionDate">
                    <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={this.state.date}
                        monthsShown={2}
                        onChange={(date: Date) => {
                            this.setState({
                                date: date
                            });
                        }
                        }
                        placeholderText={i18nService.t('dashboard.paymentForm.dateOfTransaction')}
                        maxDate={new Date()}
                    />
                </div>
                <div className="AddTransaction-Amount" key="addTransactionMoney">
                    <CurrencyInput
                        id="moneyInput"
                        name="moneyInput"
                        placeholder={i18nService.t('dashboard.paymentForm.paymentAmount')}
                        value={this.state.amount}
                        decimalsLimit={2}
                        intlConfig={{
                            currency: "EUR",
                            locale: "en-MT",
                        }}
                        onValueChange={(value, name) => {
                            this.setState({
                                amount: value!
                            });
                        }
                        }
                    />
                </div>
                <Button value={this.state.isSubmitting ? i18nService.t('dashboard.paymentForm.adding') : i18nService.t('dashboard.paymentForm.addPayment')} onClick={this.handleAddPayment} enabled={!this.state.isSubmitting}/>
            </div>
        ) : <div className="AddTransaction-Wrapper-Empty"/>;
    }
}

export default AddPayment;

